import { render, staticRenderFns } from "./SemtelPoints.vue?vue&type=template&id=5b4b0cd0&scoped=true&"
import script from "./SemtelPoints.vue?vue&type=script&lang=js&"
export * from "./SemtelPoints.vue?vue&type=script&lang=js&"
import style0 from "./SemtelPoints.vue?vue&type=style&index=0&id=5b4b0cd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4b0cd0",
  null
  
)

export default component.exports